import { hFetch } from './hFetch';

type BaseTaskArgs = {
  name: string;
  description: string;
  due_date: Date;
  contact_id: number;
};

export type CreateOneOffTaskAssignmentArgs =
  | (BaseTaskArgs & {
      assign_to_role: 'agent';
      other_user_id?: never;
    })
  | (BaseTaskArgs & {
      assign_to_role: 'other';
      other_user_id: number;
    });

export const createOneOfTaskAssignment = async (args: CreateOneOffTaskAssignmentArgs) => {
  return await hFetch({
    url: '/api/one_off_task_assignments',
    method: 'POST',
    payload: { one_off_task: { ...args, due_date: args.due_date.toISOString() } },
  });
};
